import { useAppConfig } from 'src/components/App/useAppConfig';
import type { ZoneConfig } from 'src/config';

export const useZoneFeature = (featureKey: keyof ZoneConfig) => {
  const { zoneFeatures } = useAppConfig();
  return zoneFeatures[featureKey] || false;
};
